// extracted by mini-css-extract-plugin
export var filterIncDec = "_as-0";
export var leftBorder = "_as-1";
export var rightBorder = "_as-2";
export var stringInput = "_as-3";